import type { ReactElement } from 'react'
import  { useState } from 'react'
import styled from 'styled-components'

import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { Layout } from '@/components/enlayouts/Ir'
import { AHeading } from '@/components/enlayouts/Ir/Heading'
import { Accordion } from '@/components/enlayouts/Ir/Mpocket/Accordion'

import { useMpocketScript } from '@/hooks/useMpocketScript'
import type { IrCalendar } from '@/types/irCalendar'
interface IRItem {
  published: Date;
  itemName: string;
  itemName_en: string;
  title: string;
  title_en: string;
  link: string;
  link_en: string;
  target: string;
}
interface GroupedData {
  itemName: string;
  itemName_en: string;
  items: IRItem[];
}

type IrCalendarProps = {
  items: IrCalendar[]
}
export const CalendarPage = ({items}:IrCalendarProps) => {
  useMpocketScript('//irpocket.com/141A/irpocket/config-utils-main_en.js')
  // useMpocketScript('//irpocket.com/5882/irpocket/config-utils-main_en.js')
  const groupByItemName = (data: IRItem[]): GroupedData[] => {
    const sortedData = [...data].sort(
      (a, b) => new Date(b.published).getTime() - new Date(a.published).getTime()
    );
  
    const grouped = sortedData.reduce<Record<string, GroupedData>>((acc, item) => {
      if (!acc[item.itemName]) {
        acc[item.itemName] = {
          itemName: item.itemName,
          itemName_en: item.itemName_en,
          items: [],
        };
      }
      acc[item.itemName].items.push(item);
      return acc;
    }, {});
  
    return Object.values(grouped);
  };

  const groupedData = groupByItemName(items);
  const [openStates, setOpenStates] = useState<Record<number, boolean>>(() => {
    const initialState: Record<number, boolean> = {};
    if (groupedData.length > 0) {
      initialState[0] = true;
    }
    return initialState;
  });
  const toggleOpen = (index: number) => {
    setOpenStates((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };
  return (
    <Layout>
      <SectionTitle
        color="normal"
        enTitleText="IR Calendar"
        subTitleText=""
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <section>
        <AHeading>IR Calendar</AHeading>
        <picture>
          <source
            media="(max-width: 1047px)"
            srcSet="/images/IRCalendarSP.webp"
            width="335"
            height="433"
          />
          <Image
            src="/images/IRCalendarPC2.png"
            alt="IRカレンダー"
            width="1040"
            height="300"
          />
        </picture>
      </section>
      <Spacer h={{ sp: 50, pc: 80 }} />
      <Accordion>
        {
          groupedData.map(( item, index ) => {
            const isOpen = openStates[index] || false;
            return(
            <div key={item.itemName}>
              <div onClick={() => toggleOpen(index)}>
                <span className={isOpen ? 'iZwYFc' : ''}></span>
                <h4>{item.itemName_en}</h4>
              </div>
                <div></div>
                <div className={isOpen ? '' : 'bkpqNp'}>
                  <ul>
                    {item.items.map(( a, b ) => (
                      <li key={b}>
                        <time>{formatDate(a.published)}</time>
                        <h3>
                          <p>
                            <a href={a.link_en} target={a.target}>{a.title_en}</a>
                          </p>
                        </h3>
                      </li>
                    ))}
                  </ul>
                </div>
            </div>
          )})
        }
      </Accordion>
    </Layout>
  )
}
const formatDate = (date: string | Date): string => {
  return new Date(date)
    .toLocaleDateString("zh-CN", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .replace(/\//g, "/"); 
};
CalendarPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Investor Relations', path: '/en/ir' },
    { name: 'IR Calendar', path: '' },
  ]

  return (
    <>
      <Head
        title="IR Calendar"
        description="IR event schedule."
        ogp={{ url: 'en/ir/calendar/' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle=""
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}

const Image = styled.img`
  width: 100%;
  height: 100%;
`
